import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ShActionItemComponent, ShPageHeaderComponent, ShPaginationComponent } from '@stylehaven/components';
import { DigihavenElementsModule } from '../elements/elements.module';
import { RecordModule } from '../record/record.module';
import { SavedQueriesOverviewSandboxService } from './sandbox/saved-queries-sandbox.service';
import { SavedQueriesOverviewRoutingModule } from './saved-queries-overview-routing.module';
import { SavedQueryOverviewContainerComponent } from './saved-query-overview-container/saved-query-overview-container.component';
import { DeleteSavedQueryActionCreator } from './services/delete-saved-query-action.creator';
import { RestoreSavedQueryActionCreator } from './services/load-saved-query-action.creator';

@NgModule({
    declarations: [SavedQueryOverviewContainerComponent],
    imports: [
        SavedQueriesOverviewRoutingModule,
        CommonModule,
        TranslateModule,
        DigihavenElementsModule,
        RecordModule,
        ShPageHeaderComponent,
        ShActionItemComponent,
        ShPaginationComponent
    ],
    providers: [SavedQueriesOverviewSandboxService, DeleteSavedQueryActionCreator, RestoreSavedQueryActionCreator]
})
export class SavedQueriesOverviewModule {}
